$(document).ready(function () {

// Review slider

$('.all-review-slides').slick({
    slidesToShow: 1,
    speed: 500,
    dots:true,
    arrows: false
  });

// sale discount

$('body').on('click', '.kaching-bundles__bars', function () {
setTimeout(function() {
  var C_price_text = $(".price__sale .price-item--regular").text();
  var n_price_text = $(".price__sale .price-item--sale").text();

  var C_price = parseFloat(C_price_text.replace(/[^0-9.]/g, ''));
  var n_price = parseFloat(n_price_text.replace(/[^0-9.]/g, ''));

  var sale_per = 0;

  if (C_price > n_price && C_price > 0) {
    sale_per = Math.round(((C_price - n_price) / C_price) * 100);
  }
  $('.price_sale_new .saving').text(sale_per);
}, 1000);

});

// Bundle add to cart


$(document).on("click", ".main-add-to-cart-btn", function () {

    let items = [];

    $('.add-on-pro-main .single-add-pro').each(function(){
      let variantId = $(this).attr('data-id'); 
      let qty = 1;          // example qty

      if(variantId){
        items.push({
          id: variantId,
          quantity: qty
        });
      }
    });

    if(items.length === 0){
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: items }),
      dataType: 'json',
      contentType: 'application/json',
      success: function(cart){
        $(".main-product-section .main-tri-product-btn").trigger('click');
      },
      error: function(xhr){
        console.log("Error:", xhr.responseText);
      }
    });

  });

// Cart drawer timer

  var totalSeconds = 300;
    var remainingSeconds = totalSeconds;
    function startTimer() {
      var timerInterval = setInterval(function () {
        var minutes = Math.floor(remainingSeconds / 60);
        var seconds = remainingSeconds % 60;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        $('#timer-main').text(minutes + ':' + seconds);
        remainingSeconds--;
        if (remainingSeconds < 0) {
          clearInterval(timerInterval);
          remainingSeconds = totalSeconds;
          startTimer();
        }
      }, 1000);
    }

    startTimer();
 
// Upsell product add to cart

$(document).on('click', '.add-now .upsell-pro-btn', function () {

  var $parent = $(this).closest('.single-upsell-item');
  $parent.find('.upsell-add-to-cart').trigger('click');
});

  // Remove Upsell product from cart

  $(document).on("click", ".upsell-items .added-al .upsell-pro-btn", function () {
    var upsell_pro_id = $(this).attr('data-up-id');
    $(".cart-remove-button").each(function(){
      var item_id = $(this).attr('data-product-id');
      if(upsell_pro_id == item_id){
        $(this).trigger('click');
      }
    });
    $(this).addClass('add-now');
  });

 // Remove all product from cart on remove of main product

// $(document).on("click", ".flex-tr-main .cart-remove-button", function (e) {
//   e.preventDefault();

//   fetch('/cart/clear.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   }).then(function () {
   
//   });
// });


$(document).on("click", ".cart-quantity .minus-btn", function (e) {
  e.preventDefault();

  var $wrapper = $(this).closest('.cart-quantity');
  var quantity_item = parseInt($wrapper.find('.quantity__input').val(), 10);
  if (quantity_item < 1) {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function () {
    });
  } else {
    
  }
});



});